import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ListChecks } from 'lucide-react';
import CustomInvoiceBuilder from '../../components/vendor/invoice/CustomInvoiceBuilder';
import { VendorPageHeader, VendorGuideCallout } from '../../components/vendor/guidance';
import { VENDOR_PAGE_GUIDES } from '../../utils/vendorPageGuides';

const VendorInvoiceEdit = () => {
  return (
    <div className="space-y-5">
      <div>
        <Link
          to="/vendor/invoices"
          className="inline-flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 mb-3"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to invoices
        </Link>
        <VendorPageHeader
          title="Edit invoice"
          subtitle="Update line items, dates, tax, and notes. Paid or cancelled invoices cannot be edited."
        />
      </div>
      <VendorGuideCallout
        title={VENDOR_PAGE_GUIDES.invoiceCreate.title}
        steps={VENDOR_PAGE_GUIDES.invoiceCreate.steps}
        icon={ListChecks}
        tone="slate"
      />
      <CustomInvoiceBuilder />
    </div>
  );
};

export default VendorInvoiceEdit;
